var _circle, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCircleProfileIcon = function SvgCircleProfileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 66 66",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 32,
    fill: "white",
    stroke: "#C4C4C4",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.25 51.25H12.75V44.125C12.75 42.7781 13.773 41.4447 15.6971 40.1628C17.584 38.9056 20.1357 37.8363 22.7374 36.968C25.3298 36.1028 27.928 35.4513 29.8819 35.0157C30.8578 34.7982 31.6706 34.635 32.2385 34.5264C32.5224 34.4721 32.745 34.4315 32.896 34.4045C32.9357 34.3974 32.9704 34.3913 33 34.3861C33.0296 34.3913 33.0643 34.3974 33.104 34.4045C33.255 34.4315 33.4776 34.4721 33.7615 34.5264C34.3294 34.635 35.1422 34.7982 36.1181 35.0157C38.072 35.4513 40.6702 36.1028 43.2626 36.968C45.8643 37.8363 48.416 38.9056 50.3029 40.1628C52.227 41.4447 53.25 42.7781 53.25 44.125V51.25ZM23.25 20.5C23.25 15.113 27.613 10.75 33 10.75C38.387 10.75 42.75 15.113 42.75 20.5C42.75 25.887 38.387 30.25 33 30.25C27.613 30.25 23.25 25.887 23.25 20.5Z",
    stroke: "#C4C4C4",
    strokeWidth: 1.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircleProfileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CircleProfileIcon.cd08b129.svg";
export { ForwardRef as ReactComponent };